import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'widget-quotations',
  templateUrl: './widget-quotations.component.html',
  styleUrls: ['./widget-quotations.component.scss']
})
export class WidgetQuotationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
